export default "__VITE_ASSET__EMU1epva__"